module.exports = __webpack_public_path__ + "img/icon 10@3x.18e8660a.png";